<template>
  <section>
    <div class="container no-bottom-mobile">
      <div class="is-col-12-md">
        <h1>LOG IN</h1>
        <p v-if="errors.length > 0" class="errorMsg-text" v-html="errors"></p>
        <p class="header-paragraph errorMsg-text" v-if="pwReset">
          <strong>Your password has been reset!</strong> You can now log in with your new password. </p>
        <p v-if="!pwReset">
          <span v-if="successRoute">Sorry! You need to log in to get to this page.</span> Don’t have an account yet? You
          can
          <router-link class="paragraph-link" :to="{ name: 'SignUp' }">sign up here.
          </router-link>
        </p>
      </div>
      <div class="is-col-12-md">
        <form id="loginForm" @submit.prevent="sendFormData()">
          <div class="form-row-1">
            <div class="form-field">
              <label>Email address</label> <input class="input-field" v-model="loginEmail" type="text"/>
            </div>
            <div class="form-field name-field">
              <label>Password</label> <input class="input-field" v-model="loginPassword" type="password"/>
            </div>
          </div>
          <div>
            <p>
              <router-link class="paragraph-link" :to="{
                  name: 'ForgotPassword',
                  params: { initEmail: this.loginEmail },
                }">Forgot your password?
              </router-link>
            </p>
            <p>
              <router-link class="paragraph-link" :to="{ name: 'SignUp' }">
                Don't have an account? Create one.
              </router-link>
            </p>
          </div>
          <button>
            LOG IN <span><i class="fas fa-caret-right"></i></span>
          </button>
          <div class="loader-container" v-show="showLoader">
            <img src="@/assets/images/global/loader.gif" alt=""/>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  created () {
    if (this.$store.state.isLoggedIn) {
      this.$router.push({ name: 'AccountDetail' }).catch(() => {})
    }
  },
  data () {
    return {
      loginEmail: this.$store.state.emailAddress,
      loginPassword: '',
      errors: '',
      errorMsg: '',
      pwReset: false,
      showLoader: false,
    }
  },
  props: {
    successRoute: false,
  },
  mounted () {
    if (this.successRoute) {
      this.$store.commit('LOGOUT')
      this.$gtm.trackEvent({
        event: 'authorization',
        category: 'authorization',
        action: 'attemptedAccess',
        label: this.successRoute,
      })
    }
    this.pwReset = this.$store.state.pwReset
    this.$store.state.pwReset = false
  },
  methods: {
    clear_error (field) {
      if (typeof this.errors[field] !== 'undefined') {
        delete this.errors[field]
      }
    },
    sendFormData () {
      const _this = this

      this.$store.state.emailAddress = this.loginEmail
      this.showLoader = true
      this.axios.post(_this.$apiUrl + 'v1/login', {
        email: _this.loginEmail,
        password: _this.loginPassword,
      }).then(function (response) {
        if (response.data.errors.length === 0) {
          _this.$gtm.trackEvent({
            event: 'formAction',
            category: 'Form',
            action: 'Success',
            label: 'Login Page',
            value: 0,
          })
          _this.$store.state.loginEmail = _this.loginEmail
          _this.$store.state.firstName = response.first_name
            ? response.first_name
            : 'Sun Hero'
          _this.$store.commit('SET_TOKEN', response.data)
          _this.axios.defaults.headers.common['Authorization'] =
            'Bearer ' + response.data.token
          _this.$router.push({
            name: _this.successRoute ? _this.successRoute : 'HomeLoggedIn',
          }).catch(() => {})
        } else {
          _this.errors = response.data.errors
          this.showLoader = false
          // TODO: Add error output above
        }
        _this.showResponse = true
        _this.showLoader = false
      }).catch(function (error) {
        _this.showLoader = false
        if (error.response && error.response.status == 409) {
          _this.$gtm.trackEvent({
            event: 'formAction',
            category: 'Form',
            action: 'Validation Error',
            label: 'Login Page',
            value: 1,
          })
          _this.errors = error.response.data.errors
        } else {
          _this.$gtm.trackEvent({
            event: 'formAction',
            category: 'Form',
            action: 'Error',
            label: 'Login Page',
            value: 1,
          })
          _this.errors = error
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

h1 {
  font-size: 60px;
  text-align: left;
  margin-top: 65px;
  text-transform: uppercase;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    text-align: center;
    font-size: 45px;
    margin-top: 0px;
  }
}

.container {
  @media (min-width: 1025px) {
    // padding-left: 0;
  }
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    padding-left: 2rem;
    top: 50px;
    min-height: 88vh;
  }
}

.input-field {
  width: 34.6rem;
  height: 4.5rem;
  margin-top: 1rem;
  margin-bottom: 3rem;
  box-shadow: inset 0 0 10px fade(black, 5%);
  border: 1px solid #b1b1b1;
  color: @color-txt-blue;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    width: 100%;
  }
}

form {
  margin-top: 40px;

  button {
    margin-top: 40px;
    background-color: @color-orange;
    font-weight: 700;
    font-family: @open-sans-font;
    font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
    text-transform: uppercase;
    border: none;
    padding: 1rem 1rem 1rem 1rem;
    cursor: pointer;

    span {
      margin-left: 10px;
    }

    @media screen and (max-width: 1000px) {
      // width: 226px;
      font-size: 15px;
    }

    .fa-caret-right {
      margin-left: 7px;
      @media screen and (max-width: 1000px) {
        margin-left: 3px;
      }
    }
  }
}

.loader-container {
  position: relative;
  top: -40px;
  left: 30%;
  @media screen and (min-width: ~"@{mq-md-bp}em") {
    left: 15%;
  }
}
</style>
